<h3 mat-dialog-title class="center color-grey">
  {{ ((isEdit) ? 'PROJECT.PROJECT_INFO.CHECKLIST.EDIT_COLUMN' : 'PROJECT.PROJECT_INFO.CHECKLIST.ADD_COLUMN') | anessaTranslation: trigger }}
</h3>
<form #columnForm mat-dialog-content>
  <div class="column-name">
    <div
      (mouseenter)="showClearName = true"
      (mouseleave)="showClearName = false"
      class="flex-container form-field-container">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>{{'PROJECT.PROJECT_INFO.CHECKLIST.NAME' | anessaTranslation: trigger}}</mat-label>
        <input
          matInput
          required
          [(ngModel)]="column.name"
          name="title"
          type="text">
      </mat-form-field>
      <p
        *ngIf="column.name && showClearName"
        class="form-field-clear"
        (click)="column.name = null"
        anessaTranslation="PROJECT.COMMON.CLEAR">
      </p>
    </div>
  </div>

  <div *ngIf="!isEdit" class="pad-16">
    <label>{{'PROJECT.PROJECT_INFO.CHECKLIST.COLUMN_TYPE' | anessaTranslation: trigger}}</label>
    <mat-radio-group name="colTypeGroup" [(ngModel)]="column.isIcon">
      <mat-radio-button checked [value]="false">{{'PROJECT.PROJECT_INFO.CHECKLIST.DEFAULT' | anessaTranslation: trigger}}</mat-radio-button>
      <mat-radio-button [value]="true">{{'PROJECT.PROJECT_INFO.CHECKLIST.ICON' | anessaTranslation: trigger}}</mat-radio-button>
    </mat-radio-group>
  </div>

  <ng-container *ngIf="!column.isIcon">
    <div *ngIf="showLock" class="pad-16 locked-wrapper">
      <label>{{'PROJECT.PROJECT_INFO.CHECKLIST.PREVENT_EDIT' | anessaTranslation: trigger}}</label>
      <mat-checkbox [(ngModel)]="column.locked" name="locked">{{'PROJECT.PROJECT_INFO.CHECKLIST.LOCKED' | anessaTranslation: trigger}}</mat-checkbox>
    </div>

    <div class="text-align-buttons">
      <p>{{'PROJECT.PROJECT_INFO.CHECKLIST.ALIGNMENT' | anessaTranslation: trigger}}</p>
      <mat-button-toggle-group [(ngModel)]="column.align" name="text-alignment-btn-group">
        <mat-button-toggle 
          value="left" 
          aria-label="Align text left"
          matTooltip="{{'PROJECT.PROJECT_INFO.CHECKLIST.ALIGN_LEFT' | anessaTranslation: trigger}}">
          <mat-icon>format_align_left</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle
          value="center" 
          aria-label="Center text" 
          matTooltip="{{'PROJECT.PROJECT_INFO.CHECKLIST.ALIGN_CENTER' | anessaTranslation: trigger}}">
          <mat-icon>format_align_center</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle
          value="right"
          aria-label="Align text right"
          matTooltip="{{'PROJECT.PROJECT_INFO.CHECKLIST.ALIGN_RIGHT' | anessaTranslation: trigger}}">
          <mat-icon>format_align_right</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

  </ng-container>
</form>

<mat-dialog-actions>
  <button
    mat-raised-button
    [disabled]="!column.name"
    class="btn-green"
    (click)="onSave()"
    anessaTranslation="PROJECT.COMMON.SAVE">
  </button>
  <button
    mat-raised-button
    class="btn-red"
    (click)="onCancel()"
    anessaTranslation="PROJECT.COMMON.CANCEL">
  </button>
</mat-dialog-actions>
